import React from 'react';
import './Home.js.css';
import Container from '../components/Container';
import '../styles/generics.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PageComponent from '../components/PageComponent';
import Labels from '../Labels';
import Connection from '../config/Connection';
import { Modal, Button, InputGroup, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Parsers from '../Tools/Parsers';
import GenericHelper from '../Tools/GenericHelper';
import AdminPage from './AdminPage';
import MaskedInput from '../components/MaskedInput';
import ErrorComponent from '../components/ErrorComponent';

export default class HowtoPage extends PageComponent {

  static PageInfo = {
    path: "/Help",
    name: "menu.howto",
    access: { 1: true, 2: true },
    icon: "question-circle"
  }

  constructor(props) {
    super(props);
    this.state.loading = true;
    this.state.isModalVisible = null;
    this.state.modalError = null;
    this.state.modalLoading = false;
    this.state.inputText = null;
    this.state.description = null;
    this.state.error = null;
  }

  componentDidMount() {
    Connection.Secure(Connection.service + 'HowTo')
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            setTimeout(() => this.setState({ data: data, loading: false }));
          });
        else this.setState({ error: response, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error, loading: false });
      });
  }

  downloadFile(item) {
    this.setState({ isModalVisible: "downloading" });
    Connection.Secure(Connection.service + 'HowTo/' + item.path)
      .then(res => res.blob())
      .then(blob => {
        this.setState({ isModalVisible: null });
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = item.name;
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove();  //afterwards we remove the element again 
      });
  }

  render() {
    return (
      <Container context={this.constructor}>

        <div className="generics_panels" style={{ display: "block" }}>
          {
            this.state.error != null ? <ErrorComponent error={this.state.error} /> :
              this.state.loading ? <div>{Labels.GetLabel("generic.loading")}</div> :
                <div>
                  <div className="generics_panels_header"><FontAwesomeIcon icon={this.constructor.PageInfo.icon} /> <span>{Labels.GetLabel(this.constructor.PageInfo.name)}</span></div>
                  <div dangerouslySetInnerHTML={{ __html: Labels.GetLabel("help.DESC") }} style={{ padding: 20, marginBottom: 30, borderRadius: 10, border: "1px solid rgb(240,240,240)" }}></div>
                  {this.state.data
                    && this.state.data.length > 0 ? this.state.data.map((item) =>
                      <a target="_blank" href={Connection.service + "HowTo/" + item.path} className="generics_listing_item" download >
                        <FontAwesomeIcon icon="cube" className="generics_listing_item_icon" />
                        <div className="generics_listing_content" >
                          <div className="generics_listing_item_title" >{item.name}</div>
                          <div className="generics_listing_item_description" style={{ textAlign: "right" }} >{Parsers.parseSize(item.size)}</div>
                        </div>
                      </a>
                    )
                    : <div className="generic_empty">{Labels.GetLabel('adminstategroupdetail.empty')}</div>}
                </div>
          }

          <Modal
            className={this.state.modalLoading == true ? "modal-loading" : ""}
            onHide={() => { }} show={this.state.isModalVisible != null}
          // onHide={handleClose}
          > <div>
              {Labels.GetLabel("adminuserpage.saving")}
            </div>
          </Modal>
        </div>
      </Container >
    );
  }
}